export const calculateTotalStockAmount = (stocks) => {
	return (
		stocks
			.map((st) => parseFloat(st.quantity) * parseFloat(st.rate))
			?.reduce((tot, it) => tot + it) ?? 0
	);
};
